import {
  CarouselItem,
  CarouselItemDto,
  CarouselItemId,
  CarouselPage,
  CarouselPageAssignment,
} from 'src/models/Carousel';

import { HttpService } from 'src/services';

type ConfigResponse = {
  carouselItems?: CarouselItemDto[];
  carouselConfig?: { pageAssignment?: CarouselPageAssignment[] };
};

type CarouselPageConfig = {
  page: CarouselPage;
  carouselItems: CarouselItem[];
};

abstract class CarouselService {
  static getConfig = async (): Promise<CarouselPageConfig[]> => {
    const config = await HttpService.get<ConfigResponse>('public/cms/config');
    const items = (config.carouselItems ?? []).map(CarouselItem.fromDto);
    const assignments = config.carouselConfig?.pageAssignment ?? [];
    return assignments
      .map((assignment) => {
        // Support both old format (carouselItemId) and new format (carouselItemIds)
        let carouselItemIds: CarouselItemId[] = [];
        if (
          assignment.carouselItemIds &&
          Array.isArray(assignment.carouselItemIds)
        ) {
          // New format: array of IDs
          carouselItemIds = assignment.carouselItemIds;
        } else if (assignment.carouselItemId) {
          // Old format: single ID - convert to array
          carouselItemIds = [assignment.carouselItemId];
        }

        return {
          page: assignment.page,
          carouselItems: carouselItemIds
            .map((id) => items.find((i) => i.id === id))
            .filter((item): item is CarouselItem => !!item),
        };
      })
      .filter(
        (item): item is CarouselPageConfig => item.carouselItems.length > 0,
      );
  };

  static getSingleCarousel = (id: CarouselItemId): Promise<CarouselItem> =>
    HttpService.get<CarouselItemDto>(`cms/config/carousel/${id}`).then(
      CarouselItem.fromDto,
    );
}

export default CarouselService;
